(() => {
    function getFormData() {
        const forms = document.querySelectorAll('form[kp-show-if]');
        if (!forms || forms.length < 1) {
            return null;
        }
        return Object.fromEntries(new FormData(forms[0]));
    }

    function updateShowIf() {
        const formData = getFormData();
        if (!formData) {
            return;
        }
        const elements = document.querySelectorAll('form[kp-show-if] :not(form):not([kp-show-if=update])[kp-show-if]');
        for (const element of elements) {
            const [attribute, value] = element.getAttribute('kp-show-if').split('=');
            let addAttr = null;
            let removeAttr = null;
            if (formData[attribute] === value) {
                element.style.display = null;
                addAttr = 'required';
                removeAttr = 'kp-required';
            } else {
                element.style.display = 'none';
                addAttr = 'kp-required';
                removeAttr = 'required';
            }
            const inputFields = element.querySelectorAll('input,textarea,select');
            for (const inputField of inputFields) {
                if (inputField.getAttribute(removeAttr) !== null) {
                    inputField.removeAttribute(removeAttr);
                    inputField.setAttribute(addAttr, true);
                }
            }
        }
    }

    function updateWebsiteUrl(e) {
        e.target.value = window.makeCompleteUrl(e.target.value);
    }

    function initShowIf() {
        let elements = document.querySelectorAll('form[kp-show-if] [kp-show-if=update]');
        for (const element of elements) {
            element.addEventListener('change', updateShowIf);
        }

        elements = document.querySelectorAll('#website,#website2');
        for (const element of elements) {
            element.addEventListener('blur', updateWebsiteUrl);
        }

        updateShowIf();
    }

    setTimeout(initShowIf, 50);
})();
